import { Component, OnInit, Input, HostBinding, HostListener, ChangeDetectionStrategy } from '@angular/core';

// export type variationType = 'default' | 'primary' | 'success' | 'danger';

@Component({
  selector: 'portal-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent implements OnInit {
  @Input() label: string;
  // @HostBinding('class')
  @Input() type;
  @Input() variation;
  @Input() size;
  @Input() id;
  @Input() disabled;
  btnEl;
  // @HostListener('mouseover') toggleBkgrdCol() {
  //   console.log(this);
  //   this.btnEl.style.backgroundColor= '#3e8e41';
  // }
  // constructor() { }
  ngOnInit(): void {
    this.variation = this.changeVariation(this.variation);
    // console.log(this.disabled)
    this.btnEl = <HTMLInputElement>document.getElementById(this.id).children[0];
    // console.log(this.btnEl)
    if (this.size !== undefined && this.size.length) {
      this.btnEl.classList.add(this.size);
    }
    if (this.id !== undefined && this.id.length) {
      this.btnEl.id = this.id;
    }
    if (this.disabled !== undefined) {
      this.disabled == 'true' ? this.btnEl.disabled = true: this.btnEl.disabled = false;
      // this.btnEl.disabled = this.disabled;
    }
  }
  changeVariation(variation) {
    switch(variation) {
      case 'success':
      return 'cms-green-button-reg';

      case 'primary':
      return 'cms-newuser-reg';

      case 'link':
      return 'cms-p-reg-register-cancel default';

      default:
      return 'cms-green-button-inv'
    }
  }
}
